import { md5 } from 'js-md5'; // this library works significantly faster than `crypto-js/md5`

/**
 * Returns string encoded with sha1 algorithm, returns empty string if browser does not support
 *
 * @param {string} text - Text to encode
 * @returns {Promise<string>} - Encoded string
 */
export const encodeSha1 = async (text) => {
  try {
    const encoder = new TextEncoder();
    const data = encoder.encode(text);
    const hash = await window.crypto.subtle.digest('SHA-1', data);
    return Array.from(new Uint8Array(hash))
      .map((v) => v.toString(16).padStart(2, '0'))
      .join('');
  } catch {
    return '';
  }
};

/**
 * Calculates MD5 hash of the file
 *
 * @param {Blob} file
 * @returns {Promise<string>} - MD5 hash of the file
 */
export const calculateFileMD5 = async (file) => {
  const SLICE_SIZE = 10_485_760; // 10 MiB

  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    const hasher = md5.create();

    fileReader.onload = (event) => {
      hasher.update(event.target.result);
      processNextSlice();
    };
    fileReader.onerror = reject;

    let position = 0;
    const processNextSlice = () => {
      if (position < file.size) {
        const nextPosition = Math.min(position + SLICE_SIZE, file.size);
        const slice = file.slice(position, nextPosition);
        fileReader.readAsArrayBuffer(slice);
        position = nextPosition;
      } else {
        resolve(hasher.hex());
      }
    };

    processNextSlice();
  });
};
